import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faArrowLeft,
  faTachometerAlt,
} from "@fortawesome/free-solid-svg-icons";
import Dashboard from "../../dashboard/Dashboard";
import { useTranslation } from "../../../../i18n/LanguageContext";

/**
 * MemberDashboardPanel
 * Renders the member user's read-only Dashboard inline inside the User Management
 * right detail pane, replacing the tabs.  The panel has its own "Back to Activities"
 * button so the owner can return without leaving the User Management page.
 *
 * @param {object} member        - The member user object
 * @param {function} onBack      - Callback to return to the Activity tab
 */
function MemberDashboardPanel({ member, onBack }) {
  const { t } = useTranslation();
  const memberName = member
    ? `${member.firstName} ${member.lastName}`
    : "Member";

  // No-op setHeroContent so Dashboard CTA buttons cannot navigate away.
  // All interactive CTAs are already disabled when isReadOnlyView=true, so
  // this is a safety net only.
  const noopSetHeroContent = () => {};

  return (
    <div className="um-dashboard-panel">
      {/* Panel header */}
      <div className="um-analyses-panel-header">
        <button
          className="um-analyses-back-btn"
          onClick={onBack}
          type="button"
          aria-label={t("usermgmt.analyses.backToActivities")}
        >
          <FontAwesomeIcon icon={faArrowLeft} />
          {t("usermgmt.analyses.backToActivities")}
        </button>
        <div className="um-analyses-panel-title-row">
          <FontAwesomeIcon
            icon={faTachometerAlt}
            className="um-analyses-panel-icon"
          />
          <h3 className="um-analyses-panel-title">
            {t("usermgmt.dashboard.panelTitle").replace("{name}", memberName)}
          </h3>
          <span className="um-analyses-readonly-badge">
            {t("usermgmt.analyses.readOnly")}
          </span>
        </div>
      </div>

      {/* Scrollable dashboard content */}
      <div className="um-dashboard-panel-body">
        <Dashboard
          user={member}
          setHeroContent={noopSetHeroContent}
          suppressBanner={true}
        />
      </div>
    </div>
  );
}

export default MemberDashboardPanel;
